import dynamic from "next/dynamic";

export const DynamicContent003 = dynamic(() => import("./Content003"), {
  suspense: true,
});
